export const CHECK_IDENTIFICATION = 'CHECK_IDENTIFICATION';
export const CHECK_RESET_PASSWORD_TOKEN = 'CHECK_RESET_PASSWORD_TOKEN';
export const CHECKING_RESET_PASSWORD_TOKEN = 'CHECKING_RESET_PASSWORD_TOKEN';
export const RESEND_VERIFY_EMAIL = 'RESEND_VERIFY_EMAIL';
export const RESENDING_VERIFY_EMAIL = 'RESENDING_VERIFY_EMAIL';
export const SEND_FORGET_PASSWORD_LINK = 'SEND_FORGET_PASSWORD_LINK';
export const SEND_RESET_PASSWORD_LINK = 'SEND_RESET_PASSWORD_LINK';
export const SENDING_FORGET_PASSWORD_LINK = 'SENDING_FORGET_PASSWORD_LINK';
export const SENDING_RESET_PASSWORD_LINK = 'SENDING_RESET_PASSWORD_LINK';
export const SET_IDENTIFICATION = 'SET_IDENTIFICATION';
export const SET_USER_REGISTER_FORM = 'SET_USER_REGISTER_FORM';
export const SET_USER_REGISTER_FORM_DONE = 'SET_USER_REGISTER_FORM_DONE';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const USER_ROLE = 'USER_ROLE';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATING_USER = 'UPDATING_USER';
export const USER_LOGGING = 'USER_LOGGING';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_DONE = 'USER_LOGIN_DONE';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_DONE = 'USER_LOGOUT_DONE';
export const USER_REGISTER = 'USER_REGISTER';
export const USER_REGISTERING = 'USER_REGISTERING';
export const GET_USER_INFO = 'GET_USER_INFO';
